import { sortByPriorityAndDate } from './utils'

const metrics = state => state.metrics

const onlineAudiologistsByEntity = state => state.onlineAudiologistsByEntity

const requests = state => state.requests

const infoTypes = state => state.infoTypes

const accessTypes = state => state.accessTypes

const pendingRequest = state => state.pendingRequest

const activeRequest = state => state.activeRequest

const activeAppointments = state => state.activeAppointments

const currentActiveAppointment = state => state.currentActiveAppointment

const inCall = state => state.pendingRequest !== null || state.activeRequest !== null

const activeBreak = state => state.activeBreak

const inBreak = state => state.activeBreak !== null

const activeRequestHasUnsavedPersonChanges = state => state.activeRequestHasUnsavedPersonChanges

const activeRequestHasUnsavedAppointmentChanges = state => state.activeRequestHasUnsavedAppointmentChanges

const sortedRequests = state => {
  if (Array.isArray(state.requests) && state.requests.length) {
    let requests = JSON.parse(JSON.stringify(state.requests))
    requests.sort(sortByPriorityAndDate)
    requests = requests.map((request, index) => {
      return {
        ...request,
        positionInQueue: index + 1
      }
    })
    return requests
  } else {
    return []
  }
}

const numberRequestsByPriority = state => {
  let priorities = {
    low: 0,
    normal: 0,
    high: 0
  }
  if (Array.isArray(state.requests) && state.requests.length) {
    priorities = state.requests.reduce((priorities, request) => {
      if (Object.keys(priorities).some(key => key === request.priority.name.toLowerCase())) {
        priorities[request.priority.name.toLowerCase()] += 1
      }
      return priorities
    }, priorities)
  }
  return priorities
}

export default {
  inCall,
  inBreak,
  metrics,
  requests,
  infoTypes,
  activeBreak,
  accessTypes,
  activeRequest,
  pendingRequest,
  sortedRequests,
  activeAppointments,
  currentActiveAppointment,
  numberRequestsByPriority,
  onlineAudiologistsByEntity,
  activeRequestHasUnsavedPersonChanges,
  activeRequestHasUnsavedAppointmentChanges
}
